<script>
  import { page } from '@inertiajs/svelte';
  import { slide } from 'svelte/transition';
  import FaqItem from './Item.svelte';

  export let faq;

  let showingmore = false;

  let faqItems = faq.items.filter((item) => item.id < 9);
  let faqItemsMore = faq.items.filter((item) => item.id >= 9);

  $: moreLabel = showingmore
    ? $page.props.i18n.show_less
    : $page.props.i18n.show_more;
</script>

<section class="faq">
  <div class="container">
    <p class="faq__title tagline">{faq.title}</p>
    <ol class="faq__list">
      {#each faqItems as item (item.id)}
        <li>
          <FaqItem {item} />
        </li>
      {/each}

      {#if showingmore && faqItemsMore.length}
        {#each faqItemsMore as item (item.id)}
          <li transition:slide>
            <FaqItem {item} />
          </li>
        {/each}
      {/if}
    </ol>

    {#if faqItemsMore.length}
      <div class="faq__more-wrap">
        <button
          class="faq__more-btn btn btn-icon"
          class:showingmore
          on:click={() => {
            showingmore = !showingmore;
          }}
        >
          <i class="isax isax-arrow-down-1 faq__more-btn-icon" />
          {moreLabel}
        </button>
      </div>
    {/if}
  </div>
</section>

<style lang="scss">
  .faq {
    &__title {
      text-align: center;
      color: var(--royal-light);
    }

    &__list {
      margin-top: 5rem;

      li {
        &:not(:first-child) {
          margin-top: 1.3rem;
        }
      }
    }

    &__more-wrap {
      display: flex;
      justify-content: center;
    }

    &__more-btn {
      font-size: 1.3rem;
      text-transform: uppercase;
      letter-spacing: 0.06em;
      padding: 1rem 2rem;
      border: 1px solid $light-border;
      border-radius: 30px;
      gap: 0.8rem;
      margin-top: 6rem;

      &-icon {
        font-weight: 900;
        transition: transform 0.2s;
      }

      &.showingmore {
        .faq__more-btn-icon {
          transform: rotateX(180deg);
        }
      }
    }

    ol {
      padding: 0;
      list-style: none;
    }
  }
</style>
